import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function CirclePlus(props: IconProps) {
  return (
    <IconSvg {...props} fillRule="evenodd">
      <path d="M34 18c0 8.837-7.163 16-16 16S2 26.837 2 18 9.163 2 18 2a16 16 0 0116 16zM18 8a.75.75 0 01.75.75v8.5h8.5a.75.75 0 010 1.5h-8.5v8.5a.75.75 0 01-1.5 0v-8.5h-8.5a.75.75 0 010-1.5h8.5v-8.5A.75.75 0 0118 8z"></path>
    </IconSvg>
  );
}
